import { Component, OnInit } from '@angular/core';
import { Pending } from '../../../model/questionnaires/Pending';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState, selectAuthState, selectPatientState } from '../../../store/app.states';
import { ActivatedRoute, Router } from '@angular/router';
import { GetPendings } from '../../../store/actions/patient.actions';
import * as _moment from 'moment';
// @ts-ignore
import { default as _rollupMoment } from 'moment';
const moment = _rollupMoment || _moment;
import { QuestionnaireService } from '../../../services/questionnaire.service';
import { Patient } from '../../../model/user/Patient';


@Component({
  selector: 'app-patient-clinical-pendings',
  templateUrl: './patient-clinical-pendings.component.html',
  styleUrls: ['./patient-clinical-pendings.component.css']
})
export class PatientClinicalPendingsComponent implements OnInit {

  title = 'Questionari';
  user = null;
  pendings: Pending[];
  back = true;
  getAuthState: Observable<any>;
  destination: string;
  doctorID: string;
  patientSSN: string;
  type: string;
  patient: Patient;

  constructor(private store: Store<AppState>,
    private router: Router,
    private route: ActivatedRoute,
    private questionnaireService: QuestionnaireService) {
    this.route.params.subscribe(params => {
      this.patientSSN = params.ssn;
      this.type = params.type;
      this.doctorID = params.doctorID;
      this.destination = '/patient-questionnaire-panel/' + this.patientSSN;
      if (params.back.localeCompare('global') === 0) {
        this.destination += '/global';
      } else {
        this.destination += '/local';
      }
      this.title = this.type.toUpperCase();
    });
    this.getAuthState = this.store.select(selectAuthState);
    document.addEventListener('notification', () => {
      this.getPendings();
    }
    );
  }

  ngOnInit(): void {
    this.getAuthState.subscribe((state) => {
      if (state.isAuthenticated) {
        this.user = JSON.parse(localStorage.getItem('user'));
      }
    });
    this.getPendings();
    this.setupPatient();
    console.log(this.pendings);
  }

  setupPatient() {
    const patients: Patient[] = JSON.parse(localStorage.getItem('patients'));
    this.patient = patients.find(p => p.ssn.localeCompare(this.patientSSN) === 0);
    console.log(this.patient);
  }

  getPendings() {
    this.questionnaireService.getAllClinicalPendings(this.doctorID, this.patientSSN, this.type).subscribe((pendings) => {
      this.pendings = pendings;
      console.log(this.pendings);
      if (this.pendings !== undefined && this.pendings !== null) {
        if (this.pendings.length !== 0) {
          this.pendings = this.pendings.slice().sort((p1, p2) => this.comparing(p1, p2));
        }
      }
    });
  }

  goTo(p: Pending) {
    let url = '/questionnaire-compile/' + p.type.toLowerCase() + '/' + p.uuid + '/' + p.doctorID + '/' + p.patientSSN;
    if (this.destination.includes('local')) {
      url += '/local';
    } else {
      url += '/global';
    }
    this.router.navigateByUrl(url);
  }

  comparing(r1, r2) {
    const first = r1.id.split(' ');
    const second = r2.id.split(' ');
    const d1 = moment(first[0], 'DD/MM/YYYY').toDate().getTime();
    const d2 = moment(second[0], 'DD/MM/YYYY').toDate().getTime();
    return d1 < d2 ? 1 : (d1 > d2 ? -1 : 0);
  }
}
